import React from 'react';
import PropTypes from 'prop-types';
import WinProbability from '../../Play/play/playResults/WinProbability';
import { ProbabilityWrapper } from './Summary.style';

const Probability = ({
    halfInning,
    away,
    home,
    awayTeamWinProbability,
    awayTeamWinProbabilityAdded,
    homeTeamWinProbability,
    homeTeamWinProbabilityAdded,
    isMobile
}) => {

    return (
        <ProbabilityWrapper
            isMobile={isMobile}
        >
            <WinProbability
                halfInning={halfInning}
                homeTeamName={home?.team?.abbreviation}
                awayTeamName={away?.team?.abbreviation}
                keymoments={{
                    awayTeamWinProbability,
                    awayTeamWinProbabilityAdded,
                    homeTeamWinProbability,
                    homeTeamWinProbabilityAdded
                }}
            />
        </ProbabilityWrapper>
    );
};

Probability.propTypes = {
    halfInning: PropTypes.string,
    away: PropTypes.object,
    home: PropTypes.object,
    awayTeamWinProbability: PropTypes.number,
    awayTeamWinProbabilityAdded: PropTypes.number,
    homeTeamWinProbability: PropTypes.number,
    homeTeamWinProbabilityAdded: PropTypes.number,
    isMobile: PropTypes.bool
};

export default Probability;